import { render, staticRenderFns } from "./InstructorSessionRegistration.vue?vue&type=template&id=cf5658e4&scoped=true"
import script from "./InstructorSessionRegistration.vue?vue&type=script&lang=js"
export * from "./InstructorSessionRegistration.vue?vue&type=script&lang=js"
import style0 from "./InstructorSessionRegistration.vue?vue&type=style&index=0&id=cf5658e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5658e4",
  null
  
)

export default component.exports